/* eslint-disable @typescript-eslint/no-explicit-any */
import PostDetail from '@/components/BlogDetail'
import PostList from '@/components/BlogList/PostList'
import CategorySort from '@/components/Category/CategorySort'
import { FilterHighlight } from '@/components/Category/FilterHighlight'
import { Loading } from '@/components/Loading/Loading'
import NotFoundItem from '@/components/NotFound'
import ModalFilter from '@/components/Popup/ModalFilter'
import ProductCard from '@/components/ProductCard'
import BenefitProduct from '@/components/ProductDetail/BenefitProduct'
import BundledProduct from '@/components/ProductDetail/BundledProduct'
import Promotion from '@/components/ProductDetail/EntrySummary/promotion'
import FooterProductDetailWarehouse from '@/components/ProductDetail/FooterProductDetailWarehouse'
import { Gallery } from '@/components/ProductDetail/Gallery'
import Information from '@/components/ProductDetail/Information'
import { RelatedProduct } from '@/components/ProductDetail/RelatedProduct'
import ProductCardSkeleton from '@/components/Skeleton/ProductCardSkeleton'
import { PageType, ProductStockStatus } from '@/constants'
import { useAuth, useCart, useNotification, useStore } from '@/containers'
import { ProductContextProvider } from '@/context'
import { useCategory } from '@/hooks/useCategoryHook'
import { Meta } from '@/layouts/Meta'
import { IconFilter } from '@/styles/Icon'
import { Main } from '@/templates/Main'
import type {
  GiftItems,
  Keywords,
  OtherOffers,
  PostResponse,
  Product,
  QueryParam,
} from '@/types'
import { type OrderService, type Property } from '@/types'
import { getTranslate, setContext } from '@/utils/api-interceptors'
import {
  getBottomMenu,
  getCategory,
  getCategoryMenu,
  getConfig,
  getKeywordFooter,
  getMenus,
  getPageDetail,
  getPath,
  getPosts,
  getProvinces,
  getSaleRegion,
} from '@/utils/endpoint'
import * as pixel from '@/utils/fpixel'
import { getPageTypeFromPath, stripHtmlTagsAndLimit } from '@/utils/next-util'
import { useIsomorphicLayoutEffect } from '@/utils/useIsomorphicLayoutEffect'
import { getCookies } from 'cookies-next'
import orderBy from 'lodash/orderBy'
import { type GetServerSideProps, type GetServerSidePropsContext } from 'next'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useRef, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
const PopupShare = dynamic(() => import('@/components/Popup/PopupShare'), {
  ssr: false,
})
const Specifications = dynamic(
  () => import('@/components/ProductDetail/Specifications'),
  {
    ssr: false,
  }
)
const EntrySummary = dynamic(
  () => import('@/components/ProductDetail/EntrySummary'),
  {
    ssr: false,
  }
)
interface DynamicPageProps {
  pageDetail: any
  categoryDetail: any
  pageType: string
  hideMenu: string
  keywords: Keywords
  postData: PostResponse
}
const DynamicPage = ({
  pageDetail,
  categoryDetail,
  pageType,
  hideMenu,
  postData,
}: DynamicPageProps) => {
  const router = useRouter()
  const priceRef = useRef<HTMLDivElement>(null)

  const descRef = useRef<HTMLDivElement>(null)
  const [checkSaleArea, setCheckSaleArea] = useState(true)
  const [listService, setListService] = useState<OrderService[]>([])
  const [listGift, setListGift] = useState<GiftItems[] | undefined>([])
  const [listOffer, setListOffer] = useState<OtherOffers[] | undefined>([])
  const [isOpenContact, setIsOpenContact] = useState(false)
  const [isOpenShare, setIsOpenShare] = useState(false)
  const [pickUpInStore, setPickUpInStore] = useState(false)
  const [priceWithService, setPriceWithService] = useState(0)
  const [listBundleSelected, setListBundleSelected] = useState<Product[]>([])
  useEffect(() => {
    setListBundleSelected([])
  }, [])
  const { channel } = useAuth()
  const { addToCart, cartLoading, isPreOrder, setIsPreOrder, addBundleToCart } =
    useCart()
  const {
    area,
    productCompares,
    setProductCompares,
    setIsOpenComparePopup,
    setProductViewed,
    setCatViewId,
  } = useStore()
  const productName = useMemo(() => {
    return getTranslate(pageDetail?.data?.name)
  }, [pageDetail])
  useEffect(() => {
    return () => {
      setProducts([])
      setCurrentPage(1)
    }
  }, [])
  useEffect(() => {
    return () => {
      setCurrentPage(1)
    }
  }, [categoryDetail])

  const productDescription = useMemo(() => {
    return stripHtmlTagsAndLimit(
      getTranslate(pageDetail?.data?.description),
      160
    )
  }, [pageDetail])
  const pageShortDescription = useMemo(() => {
    return stripHtmlTagsAndLimit(
      getTranslate(pageDetail?.data?.shortDescription),
      160
    )
  }, [pageDetail])
  useEffect(() => {
    if (pageDetail?.data?.preOrder && pageType == PageType.PRODUCT) {
      return setIsPreOrder(true)
    }
    return setIsPreOrder(false)
  }, [pageDetail, pageType])
  useEffect(() => {
    if (pageDetail && pageDetail.data && pageType === PageType.PRODUCT) {
      const newListService = pageDetail.data.orderServices
        ?.sort((a: any, b: any) => a?.order - b?.order)
        ?.map((e: any) => {
          if (e) {
            return { ...e, active: false }
          }
          return null
        })
        ?.filter(Boolean)
      setListService(newListService)
    }
  }, [pageDetail, pageType, channel])
  useEffect(() => {
    if (pageDetail && pageType === PageType.PRODUCT) {
      setCatViewId(pageDetail.data.catId)
      setProductViewed(
        pageDetail.data.relatedProductIds.map((e: any) => ({
          _id: e,
        }))
      )
      const mergeData = pageDetail?.data?.gifts?.reduce(
        (result: any, item: any) => {
          result.otherOffers = (result.otherOffers || []).concat(
            item.otherOffers
          )
          result.giftItems = (result.giftItems || []).concat(item.giftItems)
          return result
        },
        {} as any
      )
      const gifts = mergeData?.giftItems?.map((e: any) => {
        return { ...e, active: true }
      })
      return setListGift(gifts)
    }
  }, [pageDetail, pageType, channel])

  useEffect(() => {
    if (pageDetail && pageType === PageType.PRODUCT) {
      const mergeData = pageDetail?.data?.gifts?.reduce(
        (result: any, item: any) => {
          result.otherOffers = (result.otherOffers || []).concat(
            item.otherOffers
          )
          return result
        },
        {} as any
      )
      const offer = mergeData?.otherOffers?.map((e: any) => {
        return { content: e, active: true }
      })
      if (
        pageDetail?.data?.gifts?.filter(
          (item: { otherOffers: any }) => item.otherOffers
        ).length > 0
      ) {
        return setListOffer(offer)
      }
      return () => {
        setIsOpenComparePopup(false)
      }
    }
  }, [pageDetail, pageType, channel])
  useEffect(() => {
    const handleScroll = () => {
      const scrollPos =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      const element = document.querySelectorAll('section[id]')
      if (element !== null) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        element.forEach(function (section: any) {
          const sectionTop = section?.offsetTop - 64
          const sectionBottom = sectionTop + section?.offsetHeight
          if (scrollPos >= sectionTop - 64 && scrollPos < sectionBottom + 64) {
            document.querySelectorAll('.link-section').forEach(function (link) {
              if (link.getAttribute('data-name') === '#' + section.id) {
                link.classList.add('active')
              } else {
                link.classList.remove('active')
              }
            })
          }
        })
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  useEffect(() => {
    const e =
      pageDetail?.data?.prices?.filter(
        (item: { regionCode: string | null }) => item.regionCode == area
      ).length > 0
    return setCheckSaleArea(e)
  }, [area, router])
  useEffect(() => {
    pixel.fbqEvent('ViewContent')
  }, [])
  const [isOpenDraw, setIsOpenDraw] = useState(false)
  const {
    loading,
    setLoading,
    products,
    properties,
    highLightProperties,
    updateParams,
    activeFilters,
    currentPage,
    setCurrentPage,
    totalProduct,
    getProducts,
    setProducts,
    totalPages,
    clearFilterParams,
    applyFilterParams,
    sortByOptions,
    activeSort,
    activeSortCustom,
  } = useCategory(categoryDetail, pageDetail)
  const { categoryMenu } = useStore()
  const { systemConfig } = useNotification()

  const stockStatus = useMemo(() => {
    if (
      [
        ProductStockStatus.OUT_OF_STOCK,
        ProductStockStatus.OUT_OF_BUSINESS,
      ].includes(pageDetail?.data?.stockStatus) &&
      !pageDetail?.data?.flashSale &&
      pageType === PageType.PRODUCT
    ) {
      return true
    }
    return false
  }, [pageDetail?.data])
  const fetchMoreProducts = () => {
    setCurrentPage(currentPage + 1)
    setLoading(true)
    getProducts(
      {
        limit: 30,
        categoryDefault: categoryDetail._id,
        currentPage: currentPage + 1,
        sortBy: 'catOrder',
        sortType: 'asc',
        catDisplay: true,
        ...router.query,
      },
      {
        onSuccess: res => {
          setProducts(products.concat(res.data.data))
          setLoading(false)
        },
        onError: () => {
          setLoading(false)
        },
      }
    )
  }
  const targetRef = useRef<HTMLDivElement>(null)
  const [isReadMore, setIsReadMore] = useState(false)
  const [openSpecModal, setOpenSpecModal] = useState(false)
  const [dimensions, setDimensions] = useState(0)
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore)
  }
  useIsomorphicLayoutEffect(() => {
    let timeout: NodeJS.Timeout | null = null
    const measureHeight = () => {
      if (targetRef && targetRef.current && categoryDetail?.content) {
        setDimensions(targetRef.current.clientHeight)
      }
    }
    timeout = setTimeout(measureHeight, 400)
    return () => {
      setDimensions(0)
      setIsReadMore(false)
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [categoryDetail?.content])
  const imageGallery = pageDetail?.data?.videoUrl
    ? [
        pageDetail?.data?.videoThumbnail || '',
        ...(pageDetail?.data?.images || []),
      ]
    : pageDetail?.data?.images || []

  const updatedDescription =
    pageType === PageType.PAGE_CMS && pageDetail?.data?.content
      ? Object.fromEntries(
          Object.entries(pageDetail.data.content).map(([lang, html]: any) => [
            lang,
            html.replace(/pico\.vn/g, 'dienmaykho.vn'),
          ])
        )
      : null
  if (pageDetail && pageType === PageType.PRODUCT) {
    return (
      <Main
        // bgColor='#ffffff'
        showFooter
        meta={
          <Meta
            title={
              pageDetail?.data?.name && getTranslate(pageDetail?.data?.name)
            }
            description={pageShortDescription || productDescription || ''}
            additionalMetaTags={[
              {
                name: pageDetail?.data?.keywords,
                content:
                  pageDetail?.data?.keywords &&
                  getTranslate(pageDetail?.data?.keywords),
              },
            ]}
            imageUrl={pageDetail?.data?.thumbnail}
            canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
            dataSchema={pageDetail?.data}
            typeSchema='product'
          />
        }
        page='product-detail'
        pageLayout={PageType.PRODUCT}
      >
        <ProductContextProvider>
          <div className='wrapper mb-4 mt-2'>
            <div className='w-full flex-1 bg-white px-2 pt-3'>
              <h1 className='mb-1 break-all text-base font-semibold leading-snug text-dark-900'>
                {getTranslate(pageDetail?.data?.name)}
              </h1>
              <div className='grid grid-cols-2 items-center text-xs'>
                <div className='sku leading-none text-dark-700'>
                  SKU:{pageDetail?.data?.model}
                </div>
                <div className='share flex justify-end text-right'>
                  <button
                    className='flex items-center gap-2 text-blue'
                    onClick={() => setIsOpenShare(true)}
                  >
                    <svg
                      width='14'
                      height='15'
                      viewBox='0 0 14 15'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M11.4062 10.0785C10.8679 10.0785 10.3863 10.291 10.0179 10.6239L4.9675 7.68436C5.00292 7.52144 5.03125 7.35853 5.03125 7.18853C5.03125 7.01853 5.00292 6.85561 4.9675 6.69269L9.96125 3.78144C10.3438 4.13561 10.8467 4.35519 11.4062 4.35519C12.5821 4.35519 13.5312 3.40603 13.5312 2.23019C13.5312 1.05436 12.5821 0.105194 11.4062 0.105194C10.2304 0.105194 9.28125 1.05436 9.28125 2.23019C9.28125 2.40019 9.30958 2.56311 9.345 2.72603L4.35125 5.63728C3.96875 5.28311 3.46583 5.06353 2.90625 5.06353C1.73042 5.06353 0.78125 6.01269 0.78125 7.18853C0.78125 8.36436 1.73042 9.31353 2.90625 9.31353C3.46583 9.31353 3.96875 9.09394 4.35125 8.73978L9.39458 11.6864C9.35917 11.8352 9.33792 11.991 9.33792 12.1469C9.33792 13.2873 10.2658 14.2152 11.4062 14.2152C12.5467 14.2152 13.4746 13.2873 13.4746 12.1469C13.4746 11.0064 12.5467 10.0785 11.4062 10.0785ZM11.4062 1.52186C11.7958 1.52186 12.1146 1.84061 12.1146 2.23019C12.1146 2.61978 11.7958 2.93853 11.4062 2.93853C11.0167 2.93853 10.6979 2.61978 10.6979 2.23019C10.6979 1.84061 11.0167 1.52186 11.4062 1.52186ZM2.90625 7.89686C2.51667 7.89686 2.19792 7.57811 2.19792 7.18853C2.19792 6.79894 2.51667 6.48019 2.90625 6.48019C3.29583 6.48019 3.61458 6.79894 3.61458 7.18853C3.61458 7.57811 3.29583 7.89686 2.90625 7.89686ZM11.4062 12.8694C11.0167 12.8694 10.6979 12.5506 10.6979 12.161C10.6979 11.7714 11.0167 11.4527 11.4062 11.4527C11.7958 11.4527 12.1146 11.7714 12.1146 12.161C12.1146 12.5506 11.7958 12.8694 11.4062 12.8694Z'
                        fill='#003DD4'
                      />
                    </svg>
                    Chia sẻ
                  </button>
                </div>
              </div>
            </div>
            <section className='product_summary'>
              <Gallery
                isOutOfStock={
                  (pageDetail?.data?.stockStatus ===
                  ProductStockStatus.OUT_OF_BUSINESS
                    ? true
                    : stockStatus) || false
                }
                images={imageGallery}
                alt={productName}
                flashSale={pageDetail?.data}
                label={pageDetail?.data}
                video={pageDetail?.data?.videoUrl}
                product={pageDetail?.data}
              />
            </section>
            <section
              className='product_price mb-2 overflow-hidden rounded-b-xl'
              id='price'
              ref={priceRef}
            >
              <EntrySummary
                isOpenContact={isOpenContact}
                setIsOpenContact={setIsOpenContact}
                entrySummaryData={pageDetail?.data}
                checkSaleArea={checkSaleArea}
                setListService={setListService}
                listService={listService}
                setListGift={setListGift}
                listGift={listGift}
                setListOffer={setListOffer}
                listOffer={listOffer}
                productCompares={productCompares}
                setProductCompares={setProductCompares}
                setIsOpenComparePopup={setIsOpenComparePopup}
                pickUpInStore={pickUpInStore}
                setPickUpInStore={setPickUpInStore}
                isOutOfStock={stockStatus}
                handleInstallment={addToCart}
                priceWithService={priceWithService}
                setPriceWithService={setPriceWithService}
                handleAddToCart={addToCart}
                addToCartData={pageDetail?.data}
                cartLoading={cartLoading}
                isPreOrder={isPreOrder}
                listBundleSelected={listBundleSelected}
                handleAddBundleToCart={addBundleToCart}
              />
            </section>
            <BenefitProduct />
            <Specifications
              specifications={pageDetail?.data?.properties}
              openSpecModal={openSpecModal}
              productName={getTranslate(pageDetail?.data?.name)}
              setOpenSpecModal={setOpenSpecModal}
            />
            {pageDetail?.data?.promotions &&
              pageDetail?.data?.promotions.length > 0 && (
                <Promotion promotionData={pageDetail?.data?.promotions} />
              )}
            {pageDetail?.data?.bundledProducts && (
              <BundledProduct
                bundledProducts={pageDetail?.data?.bundledProducts}
                listBundleSelected={listBundleSelected}
                setListBundleSelected={setListBundleSelected}
                priceWithService={
                  priceWithService && priceWithService > 0
                    ? priceWithService
                    : pageDetail?.data?.finalPrice
                }
              />
            )}
            {pageDetail?.data?.relatedProducts &&
              pageDetail?.data?.relatedProducts.length > 0 && (
                <RelatedProduct
                  relatedProductData={orderBy(
                    pageDetail?.data?.relatedProducts,
                    'order',
                    'asc'
                  )}
                />
              )}

            <section
              ref={descRef}
              className='overflow-hidden rounded-xl bg-white'
              id='description'
            >
              <Information description={pageDetail?.data?.description} />
            </section>
          </div>

          {/* Footer product detail */}
          <FooterProductDetailWarehouse
            setIsOpenContact={setIsOpenContact}
            productName={getTranslate(pageDetail?.data?.name)}
            cartLoading={cartLoading}
          />
          {/* Popup comming soon */}
          <PopupShare
            setIsOpenShare={setIsOpenShare}
            isOpenShare={isOpenShare}
            data={pageDetail?.data}
          />
        </ProductContextProvider>
      </Main>
    )
  }

  if (pageDetail && pageType === PageType.PAGE_CMS) {
    return (
      <Main
        meta={
          <Meta
            title={getTranslate(pageDetail?.data?.title)}
            description={getTranslate(pageDetail?.data?.description)}
            additionalMetaTags={[
              {
                name: pageDetail?.data?.keywords,
                content:
                  pageDetail?.data?.keywords &&
                  getTranslate(pageDetail?.data?.keywords),
              },
            ]}
            imageUrl={pageDetail?.data?.thumbnail}
            canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
          />
        }
        dataHeader={getTranslate(pageDetail?.data?.title)}
        pageLayout=''
      >
        <section className='pageDetail container mt-3 min-h-[calc(100svh-60px)] bg-white pb-[80px] pt-4'>
          <div
            dangerouslySetInnerHTML={{
              __html: getTranslate(updatedDescription),
            }}
          ></div>
        </section>
      </Main>
    )
  }
  if (pageDetail && pageType === PageType.POST) {
    return <PostDetail postDetail={pageDetail?.data} hideMenu={hideMenu} />
  }

  if (categoryDetail) {
    return (
      <Main
        meta={
          <Meta
            title={getTranslate(categoryDetail.name)}
            description={getTranslate(categoryDetail.description)}
            additionalMetaTags={[
              {
                name: pageDetail?.data?.keywords,
                content:
                  pageDetail?.data?.keywords &&
                  getTranslate(pageDetail?.data?.keywords),
              },
            ]}
            imageUrl={pageDetail?.data?.thumbnail}
            canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
          />
        }
        showFooter={true}
      >
        <ModalFilter
          applyFilterParams={applyFilterParams}
          clearFilterParams={clearFilterParams}
          properties={properties}
          activeFilters={activeFilters}
          updateParams={updateParams}
          setIsOpenDraw={setIsOpenDraw}
          isOpenDraw={isOpenDraw}
          categoryMenu={categoryMenu}
          sortOptions={sortByOptions}
          activeSort={activeSort}
          activeSortCustom={activeSortCustom}
        />
        <div className='category-wrapper flex flex-wrap pt-3'>
          <div className='flex w-full flex-wrap'>
            <section className='topFilters w-full overflow-hidden'>
              <div className='container'>
                <h1 className='mb-2 text-base font-semibold text-dark-900'>
                  {getTranslate(categoryDetail.name)}{' '}
                  <span className='surfix'>giá tại kho</span>
                </h1>
              </div>
              <div className='mb-2 flex w-full items-center px-2'>
                <button
                  className='flex h-9 w-16 items-center justify-end gap-1 rounded border border-primary-base bg-white px-3 text-primary-base outline-none'
                  onClick={() => setIsOpenDraw(true)}
                  type='button'
                >
                  <IconFilter />
                  Lọc
                </button>
                {highLightProperties &&
                  highLightProperties
                    .slice(0, 1)
                    .map((e: Property) => (
                      <FilterHighlight
                        key={`e-${e._id}`}
                        filterGroup={e}
                        activeFilters={activeFilters}
                        onChange={updateParams}
                      />
                    ))}
              </div>

              <div className='container'>
                <CategorySort
                  sortOptions={sortByOptions}
                  onChange={updateParams}
                  activeSort={activeSort}
                  activeSortCustom={activeSortCustom}
                />
              </div>
            </section>
          </div>
          <section className='container flex h-full w-full flex-wrap bg-white-base pb-6 pt-3'>
            <div className='cateProductList w-full'>
              {loading && (
                <div className='products grid grid-cols-2 gap-3 pb-[120px]'>
                  {[...new Array(8)].map(() => (
                    <ProductCardSkeleton key={uuidv4()} />
                  ))}
                </div>
              )}
              {products && products.length > 0 ? (
                <>
                  <div className='products mb-6 grid grid-cols-2 gap-2'>
                    {products?.map((product, index) => (
                      <ProductCard
                        layout={2}
                        product={product}
                        key={product._id + index + 'plist'}
                        type='list'
                      />
                    ))}
                  </div>
                  {currentPage < totalPages && (
                    <div
                      className='loadMore relative mx-auto flex w-max min-w-[120px] cursor-pointer items-center justify-center gap-2 rounded-xl border border-primary-base bg-white px-4 py-1'
                      onClick={fetchMoreProducts}
                    >
                      {loading ? (
                        <Loading />
                      ) : (
                        <span className='text-center text-xs font-medium leading-normal text-primary-base'>
                          Xem thêm {totalProduct - products.length} sản phẩm
                        </span>
                      )}
                    </div>
                  )}
                </>
              ) : (
                ''
              )}
              {products && products?.length == 0 && !loading && (
                <NotFoundItem
                  label={`${
                    systemConfig?.websiteWarehouseBrandName || ''
                  } chưa có sản phẩm phù hợp với yêu cầu của bạn`}
                />
              )}
            </div>
          </section>
          {categoryDetail?.content &&
            categoryDetail?.content?.vi?.length > 0 && (
              <section
                className={`contentCategory container relative mb-5 mt-8 flex flex-wrap bg-white-base`}
              >
                <div
                  className={`content flex flex-col items-start overflow-hidden transition-height duration-300 ease-in-out ${
                    isReadMore ? 'max-h-full' : 'max-h-[100px]'
                  }`}
                >
                  <div
                    ref={targetRef}
                    dangerouslySetInnerHTML={{
                      __html: getTranslate(categoryDetail?.content),
                    }}
                  />
                </div>
                {dimensions < 100 ? (
                  ''
                ) : (
                  <div
                    className={`absolute -bottom-[60px] left-0 z-50 flex h-[100px] w-full items-end ${
                      isReadMore
                        ? ''
                        : 'bg-gradient-to-b from-white-base/0 to-white-base'
                    }`}
                  >
                    <button
                      className='readMore z-50 mx-auto mb-0 mt-auto flex w-[120px] cursor-pointer flex-col flex-wrap items-center justify-center px-3 pt-3'
                      type='button'
                      onClick={toggleReadMore}
                    >
                      <span className='text-center text-sm font-normal leading-normal text-blue'>
                        {isReadMore ? 'Thu gọn' : 'Xem thêm'}{' '}
                      </span>
                      <span className={`${isReadMore ? 'rotate-180' : ''}`}>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width={18}
                          height={19}
                          viewBox='0 0 18 19'
                          fill='none'
                        >
                          <path
                            d='M8.99999 14.2383C8.8522 14.2385 8.70584 14.2094 8.56932 14.1529C8.43279 14.0963 8.30879 14.0133 8.20444 13.9087L1.45444 7.15867C1.24606 6.94715 1.12974 6.66181 1.13087 6.36489C1.13199 6.06796 1.25046 5.78352 1.46043 5.57358C1.67041 5.36363 1.95488 5.24522 2.25181 5.24415C2.54873 5.24308 2.83404 5.35944 3.04553 5.56786L8.99999 11.5222L14.9544 5.56786C15.1659 5.35944 15.4512 5.24308 15.7482 5.24415C16.0451 5.24522 16.3296 5.36363 16.5395 5.57358C16.7495 5.78352 16.868 6.06796 16.8691 6.36489C16.8702 6.66181 16.7539 6.94715 16.5455 7.15867L9.79553 13.9087C9.69118 14.0133 9.56718 14.0963 9.43066 14.1529C9.29413 14.2094 9.14777 14.2385 8.99999 14.2383Z'
                            fill='#1E42C0'
                            fillOpacity='0.8'
                          />
                          <path
                            d='M8.99999 8.89452C8.8522 8.89471 8.70584 8.86569 8.56932 8.80912C8.43279 8.75256 8.30879 8.66957 8.20444 8.56492L2.86069 3.22117C2.65231 3.00965 2.53599 2.72432 2.53712 2.42739C2.53824 2.13046 2.65671 1.84602 2.86668 1.63608C3.07666 1.42613 3.36113 1.30772 3.65806 1.30665C3.95498 1.30558 4.24029 1.42194 4.45178 1.63036L8.99999 6.17843L13.5482 1.63036C13.7597 1.42194 14.045 1.30558 14.3419 1.30665C14.6388 1.30772 14.9233 1.42613 15.1333 1.63608C15.3433 1.84602 15.4617 2.13046 15.4629 2.42739C15.464 2.72432 15.3477 3.00965 15.1393 3.22117L9.79553 8.56492C9.69119 8.66957 9.56718 8.75256 9.43066 8.80912C9.29413 8.86569 9.14777 8.89471 8.99999 8.89452Z'
                            fill='#1E42C0'
                            fillOpacity='0.8'
                          />
                        </svg>
                      </span>
                    </button>
                  </div>
                )}
              </section>
            )}
        </div>
        <PostList post={postData?.data} />
      </Main>
    )
  }
}
export default DynamicPage

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req, res, query } = context
  const { token, language, messages } = await setContext(
    getCookies({ req, res }),
    {
      language: context.locale,
    }
  )

  let categoryDetail
  const { slug, hideMenu } = query
  if (!slug) {
    return {
      notFound: true,
    }
  }
  const path = slug[slug.length - 1].split('.')
  if (path.length > 1 && path[1].indexOf('c') > -1) {
    categoryDetail = await getCategory(path[0], query as QueryParam)
    if (!categoryDetail) {
      return {
        notFound: true,
      }
    }
  } else {
    const pathMapping =
      Array.isArray(slug) && slug.length > 1 ? slug.join('/') : slug
    const path = await getPath(pathMapping as string)
    if (path) {
      return {
        redirect: {
          permanent: true,
          source: `/${path.path}`,
          destination: `/${path.slug || path.url}`,
        },
      }
    }
  }

  const params = {
    ...query,
    limit: 30,
    sortBy: query?.sortBy ? query?.sortBy : 'catOrder',
    sortType: query?.sortType ? query?.sortType : 'asc',
    catDisplay: true,
    ...{ catId: categoryDetail?._id },
  }

  const [
    menus,
    stores,
    regions,
    categoryMenu,
    pageDetail,
    systemConfig,
    keywords,
    bottomMenu,
    postData,
  ] = await Promise.all([
    getMenus(),
    getProvinces(),
    getSaleRegion(),
    getCategoryMenu(),
    getPageDetail(path, params),
    getConfig(),
    getKeywordFooter(),
    getBottomMenu(),
    getPosts(),
  ])

  if (!pageDetail || !pageDetail.data) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      menus,
      stores,
      regions,
      language,
      messages,
      categoryMenu,
      systemConfig,
      pageDetail,
      pageType: getPageTypeFromPath(path),
      categoryDetail: categoryDetail || null,
      hideMenu: hideMenu || null,
      token: token || null,
      keywords,
      bottomMenu,
      postData,
    },
  }
}
